const separators = {
  arabicComma: '،',
  arabicPoint: '٫',
  comma: ',',
  dot: '.',
  space: ' ',
  underscore: '_',
  slash: '/',
  none: '',
};

export default separators as any;
